import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { useTranslations } from 'next-intl';

interface ViewButtonProps {
  handleCardViewButton:() => Promise<void>;
}
const ViewButton = ({ handleCardViewButton }: ViewButtonProps) => {
  const t = useTranslations();
  return (
    <div slot="footer" className="cat-u-padding-top-md">
      <CatButton
        onClick={handleCardViewButton}
      >
        {t('VIEW')}
      </CatButton>
    </div>
  );
};

export default ViewButton;
